<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		:title="
			modelId > 0 ? 'Edición de punto de venta' : 'Nuevo punto de venta'
		"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-card no-body>
			<b-tabs no-fade pills card small vertical nav-class="nav-style">
				<b-tab title="General" active>
					<b-form @submit="onSubmit">
						<FormGroupBox title="Datos">
							<b-form-row>
								<b-form-group
									:disabled="unableEdit"
									class="col-4"
									label="Nombre codigo"
								>
									<b-form-input
										type="text"
										size="sm"

										v-model="modelInfo.codename"
										required
									/>
								</b-form-group>
								<b-form-group
									:disabled="unableEdit"
									class="col-3 pl-1"
									label="Tipo Dominio"
									v-slot="{ ariaDescribedby }"
								>
									<b-form-radio
										v-model="selectedType"
										:aria-describedby="ariaDescribedby"
										name="some-radios"
										value="interno"
										>Shuttle Central</b-form-radio
									>
									<b-form-radio
										v-model="selectedType"
										:aria-describedby="ariaDescribedby"
										name="some-radios"
										value="externo"
										>Externo</b-form-radio
									>
								</b-form-group>
								<!--<b-form-group class="col-4" label="Dominio">
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.domain"
										required
									/>
								</b-form-group>-->
								<b-form-group :disabled="unableEdit" class="col-5" label="Dominio">
									<b-input-group
										v-if="selectedType == 'externo'"
									>
										<template #append>
											<b-button
												:disabled="!$hasPermission('settings.domain.validate')"
												variant="primary"
												size="sm"
												@click.prevent="validateDns"
												>Validar</b-button
											>
										</template>
										<b-form-input
											type="text"
											size="sm"
											:disabled="!$hasPermission('settings.domain.validate')"
											v-model="modelInfo.domain"
											:state="validDomain"
											required
										/>
									</b-input-group>
									<b-input-group v-else>
										<template #append>
											<b-input-group-text
												style="height: 31px;"
												><strong
													>.shuttlecentral.com</strong
												></b-input-group-text
											>
										</template>
										<b-form-input
											type="text"
											size="sm"
											v-model="modelInfo.domain"
											:state="validDomain"
											id="domain-input"
											required
										/>
									</b-input-group>
								</b-form-group>
							</b-form-row>
							<b-form-row v-if="selectedType == 'externo'">
								<b-alert show variant="warning" class="col-12">
									<strong>Importante</strong>, cuando se
									configura un dominio externo este debe estar
									apuntando al sub dominio
									<strong
										><i>book.shuttlecentral.com</i></strong
									>
									como registro CNAME, de lo contrario no
									puede ser registrado.
								</b-alert>
							</b-form-row>
							<b-form-row>
								<b-form-group :disabled="unableEdit" class="col-6" label="Descripcion">
									<b-textarea
										size="sm"
										v-model="modelInfo.description"
									/>
								</b-form-group>

								<b-form-group :disabled="unableEdit" class="col-4" label="Canal de venta">
									<b-form-select
										size="sm"
										required
										v-model="modelInfo.salesChannelId"
										:options="salesChannelsPvOpts"
									></b-form-select>
								</b-form-group>

								<b-form-group :disabled="unableEdit" class="col-2" label="Estado">
									<b-form-select
										size="sm"
										v-model="modelInfo.status"
										:options="statusOptions"
									></b-form-select>
								</b-form-group>
							</b-form-row>
						</FormGroupBox>
						<div class="text-right">
							<b-button
								@click="validateDns"
								variant="primary"
								class="mr-3"
								v-if="selectedType == 'externo' && isChangedGeneral"
								:disabled="disabledBtnDomain"
								@click.prevent="configureDns"
								>Configurar Dominio</b-button
							>
							<b-button
								variant="primary"
								type="submit"
								:disabled="!validConf"
								>{{
									modelId > 0 ? "Actualizar" : "Guardar"
								}}</b-button
							>
						</div>
					</b-form>
				</b-tab>
				<b-tab
					v-if="modelId > 0 && $hasPermission('pointOfSale.rates.show')"
					title="Destinos y Tarifas"
				>
					<FormGroupBox title="Destinos y tarifas">
						<multiselect
							v-if="$hasPermission('pointOfSale.rates.add')"
							label="text"
							track-by="value"
							placeholder="Agregar canal de venta"
							preserve-search
							:options="salesChannelsOpts"
							@search-change="
								query => (searchSalesChannelTerm = query)
							"
							@select="
								(selected, id) => addSalesChannel(selected)
							"
						/>
						<hr />
						<b-table
							:fields="ratePlansColumns"
							small
							striped
							hover
							bordered
							:items="ratePlans"
						>
							<template v-slot:cell(salesChannelName)="row">
								<h5>
									<strong>{{
										row.item.salesChannelName
									}}</strong>
								</h5>
							</template>
							<template v-slot:cell(name)="row">
								[{{ row.item.id }}] {{ row.item.name }}
								<span v-if="row.item.hasPromotions" class="text-success __shake"><md-icon icon="local_offer" class="__shake"></md-icon></span>
							</template>
							<template v-slot:cell(endDate)="{item}">
								<span>{{ item.endDate ? formatDate(item.endDate) : 'No hay vencimiento' }}</span>
							</template>
							<template v-slot:cell(startDate)="{item}">
								<span>{{ formatDate(item.startDate) }}</span>
							</template>
							<template v-slot:cell(zonedAreaName)="row">
								<h5>
									<strong>{{
										row.item.zonedAreaName
									}}</strong>
								</h5>
							</template>
							<template v-slot:cell(actions)="row">
								<div class="text-center">
									<b-form-checkbox
										:disabled="!$hasPermission('pointOfSale.rates.edit')"
										v-model="row.item.active"
										switch
										size="lg"
									/>
								</div>
							</template>
						</b-table>
						<div class="text-right">
							<b-button variant="primary" :disabled="!$hasPermission('pointOfSale.rates.edit')" @click="updateRatePlans"
								>Actualizar</b-button
							>
						</div>
					</FormGroupBox>
				</b-tab>
				<b-tab
					v-if="modelId > 0  && $hasPermission('currentExchangeRate.show')"
					title="Monedas"
				>
					<b-form @submit="updateCurrenciesSettings">
						<FormGroupBox title="Monedas">
							<b-form-checkbox-group
								switches
								:disabled="!$hasPermission('currentExchangeRate.edit')"
								size="lg"
								v-model="settings.currencies"
								:options="$root.auxVars.currencyOpts"
							>
							</b-form-checkbox-group>
						</FormGroupBox>
						<div class="text-right">
							<b-button :disabled="!$hasPermission('currentExchangeRate.edit')" type="submit" variant="primary"
								>Actualizar</b-button
							>
						</div>
					</b-form>
				</b-tab>
				<b-tab
					v-if="modelId > 0"
					title="Presentacion"
				>
					<b-row>
						<b-col cols="4">
							<FormGroupBox title="Colores">
								<label>
									Color letra principal e iconos:
									<b-form-input
										class="color-input"
										type="color"
										:disabled="unableEdit"
										v-model="settings.primaryColor"
									/> </label
								><br />
								<label>
									Color de fondo de boton:
									<b-form-input
										class="color-input"
										type="color"
										:disabled="unableEdit"
										v-model="settings.btnBackground"
									/> </label
								><br />
								<label>
									Color letra de boton:
									<b-form-input
										class="color-input"
										type="color"
										:disabled="unableEdit"
										v-model="settings.btnColor"
									/> </label
								><br />
								<label>
									Color fondo general:
									<b-form-input
										class="color-input"
										type="color"
										:disabled="unableEdit"
										v-model="settings.background"
									/>
								</label>
								Ejemplo:
								<b-card
									:style="`background:${settings.background}`"
								>
									<b-button
										:style="
											`background:${settings.btnBackground};color:${settings.btnColor};border:none`
										"
										href="#"
										variant="primary"
										block
										>RESERVA AQUI</b-button
									>
								</b-card>
							</FormGroupBox>
						</b-col>
						<b-col cols="4">
							<FormGroupBox title="Empresa">
								<label>
									Nombre publico
									<b-form-input
										:disabled="unableEdit"
										class="color-input"
										type="text"
										v-model="settings.publicName"
										size="sm"
									/> </label
								><br />
								<b-form-checkbox
									size="sm"
									:disabled="unableEdit"
									v-model="settings.showNewsletter"
									>Mostrar newsletter</b-form-checkbox
								>
							</FormGroupBox>
						</b-col>
					</b-row>
					<div class="text-right">
						<b-button
							@click="updateSettings('presentation')"
							variant="primary"
							>Actualizar</b-button
						>
					</div>
				</b-tab>
				<b-tab
					v-if="modelId > 0  && $hasPermission('settings.media.show')"
					title="Media"
				>
					<FilesRelated
						:model-id="modelId"
						:unableEdit="!$hasPermission('settings.media.update')"
						:unableDelete="!$hasPermission('settings.media.delete')"
						model-reference="point-of-sales"
						:file-keys="[
							{ label: 'Header Logo', keyName: 'headerLogo' },
							{ label: 'Footer Logo', keyName: 'footerLogo' },
							{ label: 'Home Banner', keyName: 'homeBanner' }
						]"
					/>
				</b-tab>
				<b-tab
					v-if="modelId > 0"
					title="Empresa"
				>
					<b-row>
						<b-col cols="5">
							<FormGroupBox title="Contacto">
								<b-form-group label="Nombre legal">
									<b-form-input
										type="text"
										size="sm"
										:disabled="unableEdit"
										v-model="settings.legalName"
										required
									/>
								</b-form-group>
								<b-form-group label="Telefono contacto">
									<b-form-input
										type="text"
										size="sm"
										:disabled="unableEdit"
										v-model="settings.contactPhone"
										required
									/>
								</b-form-group>
								<b-form-group label="Sitio web">
									<b-form-input
										type="text"
										size="sm"
										:disabled="unableEdit"
										v-model="settings.website"
										required
									/>
								</b-form-group>

								<b-form-group label="Correos de notificacion">
									<b-form-input
										type="email"
										size="sm"
										class="mt-3"
										:disabled="unableEdit"
										v-model="settings.emailNotifications"
										required
									/>

									<b-input-group
										class="mt-3"
										:disabled="unableEdit"
										v-for="(i, index) in emailNotifications"
										:key="index"
									>
										<template #append>
											<b-button
												:disabled="unableEdit"
												@click.prevent="
													removeEmailNotifications(
														index
													)
												"
												variant="danger"
												><md-icon icon="delete"
											/></b-button>
										</template>
										<b-form-input
											placeholder="Correo electronico"
											v-model="emailNotifications[index]"
											required
										></b-form-input>
									</b-input-group>
								</b-form-group>
								<b-button
									@click.prevent="addEmailNotifications"
									block
									:disabled="unableEdit"
									class="mt-3"
									>Agregar correo</b-button
								>

							</FormGroupBox>
						</b-col>
						<b-col cols="6">
							<FormGroupBox title="Redes sociales">
								<b-form-group :disabled="unableEdit" label="Facebook">
									<b-form-input
										type="text"
										size="sm"
										v-model="settings.facebook"
										required
									/>
								</b-form-group>
								<b-form-group :disabled="unableEdit" label="Twitter">
									<b-form-input
										type="text"
										size="sm"
										v-model="settings.twitter"
										required
									/>
								</b-form-group>
							</FormGroupBox>
						</b-col>
					</b-row>
					<div class="text-right">
						<b-button
							@click="updateSettings('company')"
							variant="primary"
							>Actualizar</b-button
						>
					</div>
				</b-tab>
				<b-tab
					v-if="modelId > 0 && $hasPermission('pointOfSale.settings.show')"
					title="Configuracion"
				>
					<b-row>
						<b-col>
							<table class="table table-striped">
								<tr>
									<th>Opción</th>
									<th>Descripcion</th>
									<th></th>
								</tr>
								<tr>
									<td>Activar traveler portal</td>
									<td>
										Controla la visibilidad del boton que
										redirecciona al traveler portal en el
										voucher
									</td>
									<td>
										<b-form-checkbox
											size="lg"
											v-model="
												settings.enableTravelersPortal
											"
										></b-form-checkbox>
									</td>
								</tr>
								<tr>
									<td>Activar informacion de contacto</td>
									<td>
										Se usará la información de contacto del
										punto de venta en el voucher y los
										mensajes dentro del Booking engine (<b
											>Default:</b
										>
										Contacto de SC)
									</td>
									<td>
										<b-form-checkbox
											size="lg"
											v-model="settings.enableContactInfo"
										></b-form-checkbox>
									</td>
								</tr>
								<tr>
									<td>Activar logos</td>
									<td>
										Se usará los logos del punto de venta en
										el voucher que se le envía al cliente al
										concretar su compra (<b>Default:</b>
										Logos de SC)
									</td>
									<td>
										<b-form-checkbox
											size="lg"
											v-model="settings.enableLogos"
										></b-form-checkbox>
									</td>
								</tr>
								<tr>
									<td>Renta de autos whitelabel (AVIS)</td>
									<td>
										Activacion de venta de renta de autos usando el whitelabel de AVIS
									</td>
									<td>
										<b-form-checkbox
											size="lg"
											v-model="settings.enableCarRentalWhitelabel "
										></b-form-checkbox>
									</td>
								</tr>
								<tr>
									<td>Tiempo de cut off en horas.</td>
									<td>
										El tiempo previo que se debe respetar
										para hacer una reserva. (<b>Default:</b>
										24 horas)
									</td>
									<td>
										<b-form-input
											type="number"
											size="md"
											min="0"
											v-model="settings.cutoffHours"
										></b-form-input>
									</td>
								</tr>
								<tr>
									<td>
										Pickup default
										Lugar de pickup por default que aparecera en el cotizador
									</td>
									<td colspan="2" >
										<vue-typeahead-bootstrap
											showAllResults
											size="sm"
											placeholder="Buscar"
											v-model="pickupPlaceSearch"
											:serializer="place => place.name"
											:data="placesData"
											@hit=" selected => setPlace(selected,'pickup')"
										>
											<template #suggestion="{ data, htmlText }">
												<span v-html="htmlText"></span><br/><small>{{ data.address }}</small>
											</template>
											<template v-slot:append>
												<b-button variant="warning" @click="clearPlace('pickup')">
													<b-spinner v-if="pickupDefaultLoading" small />
													<span v-else>X</span>
												</b-button>
											</template>
										</vue-typeahead-bootstrap>
									</td>
								</tr>
								<tr>
									<td>
										Dropoff default
										Lugar de dropoff por default que aparecera en el cotizador
									</td>
									<td colspan="2" >
										<vue-typeahead-bootstrap
											showAllResults
											size="sm"
											placeholder="Buscar"
											v-model="dropoffPlaceSearch"
											:serializer="place => place.name"
											:data="placesData"
											@hit=" selected => setPlace(selected,'dropoff')"
										>
											<template #suggestion="{ data, htmlText }">
												<span v-html="htmlText"></span><br/><small>{{ data.address }}</small>
											</template>
											<template v-slot:append>
												<b-button variant="warning" @click="clearPlace('dropoff')">
													<b-spinner v-if="dropoffDefaultLoading" small />
													<span v-else>X</span>
												</b-button>
											</template>
										</vue-typeahead-bootstrap>
									</td>
								</tr>
							</table>
						</b-col>
					</b-row>
					<div class="text-right">
						<b-button
							:disabled="!$hasPermission('pointOfSale.settings.save')"
							@click="updateSettings('configWhiteLabel')"
							variant="primary"
							>Actualizar</b-button
						>
					</div>
				</b-tab>
				<b-tab
					v-if="modelId > 0 "
					title="Api Keys"
				>
					<ApiKeys
						:conf="{
							keys: apiKeys.rows,
							idpointsale: this.modelInfo.id
						}"
					/>
				</b-tab>
			</b-tabs>
		</b-card>
	</b-modal>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import FormGroupBox from "@/components/helpers/FormGroupBox";
import Multiselect from "vue-multiselect";
import FilesRelated from "@/components/helpers/FilesRelated";
import { debounce } from "debounce";
import ApiKeys from "./apiKey.vue";
import moment from 'moment'

export default {
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		},
		unableEdit: {
			type: Boolean,
			default: false
		}
	},
	components: { FormGroupBox, Multiselect, FilesRelated, ApiKeys, VueTypeaheadBootstrap },
	data() {
		return this.initialData()
	},
	computed: {
		disabledBtnDomain(){
			if(!this.$hasPermission('settings.domain.configDns')){
				return true
			}
			return !this.validDomainIp
		},
		currencies() {
			return this.settings.currencies;
		},
		serviceTypesOpts() {
			return this.$root.auxVars.serviceTypesOpts.filter(
				st => st.value != 1
			);
		},
		validConf() {
			if (this.selectedType === "interno") {
				return true;
			} else {
				return this.isConfiguredDomain;
			}
		},
		validDomain() {
			let t = null;
			// selectedType
			if (this.selectedType === "interno") {
				t = this.modelInfo.domain.match(/\./gm);
				if (t === null) {
					return true;
				}
			} else {
				t = this.modelInfo.domain.match(
					/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)/g
				);
				if (t) {
					return true && this.validDomainIp;
				} else {
					return false;
				}
			}
			return false;
		},
		generalDomain() {
			/**
			 * Metodo para validar los diferentes elementos que corresponden al tab
			 * de general.
			 */
			if (this.isChangedGeneral) {
				return this.validDomainIp;
			}
			return true;
		},
		salesChannelsPvOpts(){
			return this.$root.auxVars.salesChannelsOpts;
		}
	},
	methods: {
		initialData(){
			let defaultModelInfo = {
				id: -1,
				codename: "",
				description: "",
				domain: "",
				salesChannelId: null,
				status: "active"
			};
			let defaultSettings = {
				background: "#E5E3FF",
				btnColor: "#ffffff",
				primaryColor: "#5D59D4",
				btnBackground: "#5D59D4",
				requireLogin: false,
				currencies: ["usd"],
				stripePublicKey: "",
				stripeSecretKey: "",
				stripeCurrency: "mxn",
				emailNotifications: "",
				contactPhone: "",
				legalName: "",
				facebook: "",
				twitter: "",
				website: "",
				enableTravelersPortal: false,
				enableLogos: false,
				enableCarRentalWhitelabel: false,
				enableContactInfo: false,
				cutoffHours: "",
				pickupPlaceDefaultId:0,
				dropoffPlaceDefaultId:0,
			};
			return {
				selectedType: "interno",
				searchSalesChannelTerm: "",
				ratePlans: [],
				apiKeys: [],
				modelId: -1,
				loading: true,
				serviceTypesIds: [],
				settings: { ...defaultSettings },
				modelInfo: { ...defaultModelInfo },
				defaultModelInfo: { ...defaultModelInfo },
				salesChannelsOpts: [],
				statusOptions: [
					{ value: "active", text: "Activo" },
					{ value: "inactive", text: "Inactivo" }
				],
				ratePlansColumns: [
					{ key: "salesChannelName", label: "Canal de venta" },
					{ key: "zonedAreaName", label: "Area" },
					{ key: "name", label: "Nombre" },
					{ key: "startDate", label: "Fecha inicio" },
					{ key: "endDate", label: "Fecha fin" },
					{ key: "currency", label: "Moneda" },
					{ key: "rateType", label: "Tipo" },
					{ key: "actions", label: "Activo" }
				],
				currentTab: "general",
				emailNotifications: [],
				validDomainIp: false,
				messageErrorDomain: "El dominio no cumple el formato correcto",
				isChangedGeneral: false,
				isConfiguredDomain: false,
				domainCache: '',
				placesData:[],

				pickupPlaceSearch:'',
				dropoffDefaultLoading:false,
				pickupDefaultLoading:false,
				dropoffPlaceSearch:'',
				dropoffPlaceSearchLoading:false,
				pickupDefault:{ref:'',name:''},
				dropoffDefault:{ref:'',name:''},
			};
		},
		formatDate(date) {
			if (date) return moment(date).format("YYYY-MM-DD")
		},
		validateEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		addEmailNotifications() {
			// agregar vacio
			this.emailNotifications.push("");
		},
		removeEmailNotifications(index) {
			this.emailNotifications.splice(index, 1);

			// Mantener un input
			if (this.emailNotifications.length < 1) {
				this.emailNotifications.push("");
			}
		},
		configureDns (ev) {
			// actualiza las monedas validas y después los tipos de cambio
			ev.preventDefault();
			this.loading = true;

			let data = Object.assign(
				{},
				JSON.parse(
					JSON.stringify(this.modelInfo)
				)
			)

			// Agregar el complemento cuando es dominio interno
			if (this.selectedType === "interno") {
				data.domain = `${this.modelInfo.domain}.shuttlecentral.com`;
			}

			this.$root.api
				.post(`/point-of-sales/${this.modelInfo.id}/configure-dns`, data)
				.then(() => {
					this.$root.showAlert("El dominio fue configurado");
					this.isConfiguredDomain = true;
				})
				.catch(this.$root.handleRequestError).finally ( () => {
					this.loading = false;
				});
		},
		validateDns() {
			this.loading = true;

			this.$root.api
				.post(`/point-of-sales/valid-domain`, {
					domain: this.modelInfo.domain
				})
				.then(resp => {
					this.validDomainIp = resp.data.valid;
					if (!resp.data.valid) {
						this.$root.showAlert(
							"El dominio no se apunta de forma correcta a book.shuttlecentral.com"
						);
					}
				})
				.catch((err) => {
					this.validDomainIp = false;
					this.$root.handleRequestError(err);
				}).finally( () => {
					this.loading = false;
				});
		},
		updateCurrenciesSettings(ev) {
			// actualiza las monedas validas y después los tipos de cambio
			ev.preventDefault();
			this.loading = true;
			this.$root.api
				.put(`/point-of-sales/${this.modelInfo.id}/setting-vars`, {
					settings: { currencies: this.settings.currencies }
				})
				.then(() => {
					this.$root.showAlert("Monedas actualizadas");
					this.loading = false;
				})
				.catch(this.$root.handleRequestError);
		},
		updateRatePlans() {
			let ids = this.ratePlans.filter(rp => rp.active).map(rp => rp.id);
			this.loading = true;
			this.$root.api
				.put(`/point-of-sales/${this.modelInfo.id}/rate-plans`, {
					ratePlans: ids
				})
				.then(() => {
					this.$root.showAlert("Tarifas actualizadas");
					this.loadRatePlans();
					this.loading = false;
				})
				.catch(this.$root.handleRequestError);
		},
		addSalesChannel(selected) {
			if (
				this.ratePlans.find(
					rt => rt.salesChannelId == selected.value
				) == null
			) {
				this.$root.api
					.get(`/sales-channels/${selected.value}/rate-plans`)
					.then(res => {
						let ratePlansAux = res.data.map(rp => ({
							salesChannelName: selected.text,
							...rp,
							active: false
						}));
						if (ratePlansAux.length > 0) {
							this.ratePlans = [
								...this.ratePlans,
								...ratePlansAux
							];
						} else {
							this.$root.showAlert(
								`El canal ${selected.text} no tiene tarifas configuradas`,
								{ variant: "warning" }
							);
						}
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.$root.showAlert(
					`Este canal ${selected.text} ya ha sido agregado`,
					{ variant: "danger" }
				);
			}
		},
		async searchSalesChannel(query) {
			this.salesChannelsOpts = await this.$root.auxVars.search(
				this,
				"/sales-channels/search",
				query
			);
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}

			// Agregar el complemento cuando es dominio interno
			if (this.selectedType === "interno") {
				this.modelInfo.domain = `${this.modelInfo.domain}.shuttlecentral.com`;
			}

			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/point-of-sales/${this.modelId}`
						: "/point-of-sales",
				method: this.modelId > 0 ? "put" : "post"
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert("OK!");
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;

					// Solo en caso que existta un cambio, mandar borrar la cache
					if (this.modelId > 0) {
						this.$root.api.get(`/point-of-sales/clean-cache`);
					}

				}).finally( () => {
					this.asignDomain(this.modelInfo.domain);
				});
		},
		loadModel(id) {
			Object.assign(this.$data, this.initialData());
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['salesChannelsOpts']})
			this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["serviceTypesOpts"],
				forceRefresh: true
			});
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		asignDomain (domain) {
			// Asignando tipo de dominio
			let rt = domain.split(".");
			if (rt.length > 2) {
				if (rt[1] === "shuttlecentral") {
					this.selectedType = "interno";
					this.modelInfo.domain = rt[0]; // Solo subdominio
				} else {
					this.selectedType = "externo";
				}
			} else {
				this.selectedType = "externo";
			}
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.$emit('update:unableEdit',!this.$hasPermission('pointOfSale.edit'))
				this.loading = true;
				this.$root.api
					.get(`/point-of-sales/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.settings = { ...res.data.settingVars };
						this.loadDefaultPlaces()
						this.loadApiKeys();
						this.loadRatePlans();
						this.loading = false;

						if(this.settings.emailNotificationsExtra === undefined) {
							this.settings.emailNotificationsExtra = "";
						}

						let emails = this.settings.emailNotificationsExtra.split(
							","
						);

						if (emails.length < 1) {
							emails.push("");
						}

						this.emailNotifications = emails;
						this.asignDomain(this.modelInfo.domain);
					})
					.catch((e) => {
						console.log(e);
						this.$root.handleRequestError(e);
					});
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.settings = { ...this.defaultSettings };
				this.loading = false;
			}
		},
		loadDefaultPlaces(){
			if(this.settings.pickupPlaceDefaultId>0){
				this.$root.api
					.get(`/places/${this.settings.pickupPlaceDefaultId}`)
					.then(res => {
						this.pickupDefault = res.data;
						this.pickupPlaceSearch = res.data.name;
					});
			}
			if(this.settings.dropoffPlaceDefaultId>0){
				this.$root.api
					.get(`/places/${this.settings.dropoffPlaceDefaultId}`)
					.then(res => {
						this.dropoffDefault = res.data;
						this.dropoffPlaceSearch = res.data.name;
					});
			}
		},
		loadRatePlans() {
			if (this.modelId > 0 ) {
				this.$root.api
					.get(`/point-of-sales/${this.modelId}/rate-plans`)
					.then(res => {
						let rp = res.data;
						rp = rp.map((item=>{
							let add = {_rowVariant:""};
							if(item.expired??false){
								add._rowVariant="danger";
							}
							item = {...item,...add}
							return item;
						}))
						this.ratePlans = rp;
					})
					.catch(this.$root.handleRequestError);
			}
		},
		loadApiKeys() {
			if (this.modelId > 0 ) {
				this.$root.api
					.get(`/point-of-sales/${this.modelId}/api-keys`)
					.then(res => {
						this.apiKeys = [];
						this.apiKeys = res.data;
					})
					.catch(this.$root.handleRequestError);
			}
		},
		updateSettings(groupName) {
			let settings = {};
			if (groupName == "presentation") {
				settings = {
					publicName: this.settings.publicName,
					primaryColor: this.settings.primaryColor,
					btnBackground: this.settings.btnBackground,
					btnColor: this.settings.btnColor,
					background: this.settings.background,
					showNewsletter: this.settings.showNewsletter
				};
			} else if (groupName == "company") {
				let eml = [];
				this.emailNotifications.forEach( (elm) => {
					if (this.validateEmail(elm)) {
						eml.push(elm)
					}
				});
				settings = {
					emailNotificationsExtra: eml.join(","),
					emailNotifications: this.settings.emailNotifications,
					contactPhone: this.settings.contactPhone,
					legalName: this.settings.legalName,
					website: this.settings.website,
					facebook: this.settings.facebook,
					twitter: this.settings.twitter
				};
			} else if (groupName == "stripe") {
				settings = {
					stripePublicKey: this.settings.stripePublicKey,
					stripeSecretKey: this.settings.stripeSecretKey,
					stripeCurrency: this.settings.stripeCurrency
				};
			} else if (groupName == "configWhiteLabel") {
				if (this.settings.cutoffHours < 0) {
					this.$root.showAlert(
						"No se pueden configurar horas negativas",
						{ variant: "warning" }
					);
					this.loading = false;
					return false;
				}

				settings = {
					enableTravelersPortal: this.settings.enableTravelersPortal,
					enableLogos: this.settings.enableLogos,
					enableCarRentalWhitelabel: this.settings.enableCarRentalWhitelabel,
					enableContactInfo: this.settings.enableContactInfo,
					cutoffHours: this.settings.cutoffHours,
					pickupDefault: this.pickupDefault.ref,
					dropoffDefault: this.dropoffDefault.ref,
				};
			}
			this.loading = true;

			this.$root.api
				.put(`/point-of-sales/${this.modelInfo.id}/setting-vars`, {
					settings
				})
				.then(() => {
					this.$root.showAlert("Configuraciones actualizadas");
					this.loading = false;
				})
				.catch(this.$root.handleRequestError);
		},
		searchPlace(term){
			if (term!='') {
				this.placeSearchLoading = true
				this.$root.api.post(`/places/search`,{ term }).then( (res) => {
					this.placesData = res.data
					this.placeSearchLoading = false
				}).catch( err => {
					console.log('Error', err)
				});
			}
		},
		setPlace(selected, type){
			this[`${type}Default`] = {...selected}
		},
		clearPlace(type){
			this[`${type}Default`] = {ref:'',name:''}
			this[`${type}PlaceSearch`] = ''
		}
	},
	mounted() {},
	watch: {
		searchSalesChannelTerm: debounce(function(term) {
			this.searchSalesChannel(term);
		}, 500),
		'modelInfo.domain': function (n, o) {
			if(o !== '') {
				if (this.domainCache === n) {
					this.isChangedGeneral = false;
					this.isConfiguredDomain = true;
					this.validDomainIp = true;
				} else {
					this.isChangedGeneral = true;
					this.validDomainIp = false;
					this.isConfiguredDomain = false;
				}
			} else {
				this.domainCache = n;
				this.isChangedGeneral = false;
				this.isConfiguredDomain = true;
				this.validDomainIp = true;
			}
		},
		pickupPlaceSearch: debounce(function(term) { this.searchPlace(term) }, 500),
		dropoffPlaceSearch: debounce(function(term) { this.searchPlace(term) }, 500),
	}
};
</script>

<style scoped>
.logo img {
	padding: 0.5em;
}
.color-input {
	width: 180px;
}
.btn-example {
	display: flex;
	justify-content: center;
	flex-direction: column;
}

</style>
